"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section data-section-id="173329" id="headline" className="relative w-full min-h-[80vh] md:min-h-[800px] flex flex-col justify-start overflow-hidden bg-background dark">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611703/img/hero_coffee_beans_bg.png)] bg-cover bg-center bg-no-repeat" />
        {}
        <div className="absolute inset-0 bg-background/90 backdrop-blur-sm" />
      </div>

      {}
      <div className="relative z-10 w-full max-w-[1600px] mx-auto px-6 pt-32 pb-24 md:pt-[160px] md:pl-[128px] lg:pl-[160px] flex-1 flex flex-col">
        <div ref={ref} className={`max-w-2xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="font-sans text-5xl md:text-[80px] font-black leading-[1.1] md:leading-[1] text-primary mb-6 tracking-tighter drop-shadow-[0_0_20px_rgba(255,102,0,0.3)]">
            Split the Meal. Pay Half.
          </h1>
          
          <p className="font-sans text-lg md:text-[20px] text-muted-foreground font-medium leading-relaxed mb-10 max-w-xl">
            Join Toronto's fastest-growing food community. Create shared orders with neighbors, meet new people, and slash your dining costs in real-time with HalfOrder.
          </p>
          
          <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full h-[56px] px-8 py-4 shadow-xl font-sans text-base font-bold border-0 transition-transform hover:scale-105 active:scale-95">
            <Link to="/DownloadPage">
              Start Saving Now
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}